<template>
  <div
    v-if  = "judgeBox"
    class = "vipLabel"
    @click     = "stopDocument($event)"
    :style     = "styleData"
    @mouseover = "stopDocument($event);"
    :class="'label_' + labelType"
  >
    <span
      v-if="labelType == 'vip'"
    >
      VIP
    </span>

    <span
      v-if="labelType == 'price'"
      :style="{
        'display' : itemData.priceOfPromotion ? 'flex' : 'inline-block',
        'justify-content' : itemData.priceOfPromotion ? 'space-evenly' : 'end',
      }"
    >
      <span
        :class="{
          'price_promotion' : 'priceOfPromotion' in itemData,
        }"
      >¥{{itemData.price}}</span>

      <span
        v-if="'priceOfPromotion' in itemData"
      >¥{{itemData.priceOfPromotion}}</span>
    </span>

    <span
      v-if="labelType == 'solo'"
    >
      VIP
    </span>

    <span
      v-if="labelType == 'payOk'"
    >
      已购买
    </span>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'


export default {
  mixins: [],
  props: ['payType', 'itemData', 'boxName'],
  data () {
    return {
      judgeBox  : false,
      labelType : 'vip',
      styleData : {},
    }
  },
  computed: {
    ...mapGetters([
      'UserEquity',
      'UserMsg'
    ])
  },
  watch: {
    StyleMsg: function() {

    }
  },
  mounted () {

    this.judgeBoxFS();
  },
  methods: {
    stopDocument(e){ // 防止事件冒泡
      e.stopPropagation();
    },
    judgeBoxFS(){ // 判断是否显示
      let arr = (this.UserEquity.soloLimit || '').split('-');
      switch(this.payType){
        case 4:
          if(
            this.UserEquity.soloLimit &&
            arr.indexOf(this.itemData.fileType+'') >= 0
          ){

            this.labelType = 'vip';
          }else{

            this.labelType = 'solo';
          }
          if(this.UserEquity.exclusive){

            if(
              this.UserEquity.soloLimit &&
              arr.indexOf(this.itemData.fileType+'') >= 0
            ){

              this.judgeBox = true;
            }else{

              this.judgeBox = false;
            }
          }else{
            this.judgeBox = true;
          }
          break;
        case 1:
          if (this.UserMsg.payForMaterial == 1) {
            this.judgeBox = false;
          } else if(this.itemData.tt){
            this.labelType = 'payOk';
            this.judgeBox  = true;
          }else{
            this.labelType = 'price';
            this.judgeBox  = true;
          }
          break;
        default:
          this.judgeBox = false;
          break;
      }

      this.judgeboxStyleFS();
    },
    judgeboxStyleFS(){ // 根据类型，调整标志的style
      // console.log(this.itemData, this.boxName);
      // 4 — 会员专属 1 — 单独付费 0 — 免费

      switch(this.boxName){
        case 'text':
        case 'characters':
        case 'props':
        case 'gif':
          this.styleData = {
            zIndex : 20,
            right  : '4px',
          };
          if(this.labelType == 'price'){
            this.styleData = {
              zIndex : 20,
              right  : '2px',
              width  : '72px',
            };
          }
          break;
        // case 'props':
        //   this.styleData = {
        //     zIndex : 20,
        //     right   : '5px',
        //   };
        //   break;
        // case 'sound':
        //   this.styleData = {
        //     zIndex : 20,
        //     right   : '5px',
        //   };
        //   break;
        default:
          this.styleData = {
            zIndex : 20,
            right   : '4px',
          };
          break;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  .vipLabel{
    position: absolute;
    bottom: 5px;
    width: auto;
    max-width: 72px;
    height: 18px;
    color: #fff;
    border-radius: 5px;
    line-height: 18px;
    padding: 0 7px;
    overflow: hidden;
    font-family: MicrosoftYaHei-Bold;
    font-size: 12px;
    font-weight: 700;
    font-stretch: normal;
    letter-spacing: 0px;

    .price_promotion{
      position: relative;
      display: inline-block;
      // text-decoration: line-through;
      transform: scale(0.85);
      margin-right: 0.3em;

      &::after {
        content: ' ';
        position: absolute;
        left: -10%;
        top: 50%;
        width: 120%;
        background-color: #fff;
        height: 1.6px;
      }
    }
  }
  .label_vip{
    line-height: 14px;
    height: 14px;
    background-image: linear-gradient(108deg, #36332f 0%, #12100a 100%);
    border-radius: 7px;
  	border: solid 1px #ffffff;
    color: #f9d8a4;
    box-shadow: 0px 0px 4px 0px rgba(148, 74, 14, 0.49)
  }
  .label_solo{
    line-height: 14px;
    height: 14px;
    color: #ffffff;
    background-image: linear-gradient(-62deg,	#c29484 0%, #f1d9c9 100%);
	  border-radius: 7px;
	  border: solid 1px #ffffff;
  }
  .label_payOk,
  .label_price{
    padding: 0 5px;
    background-image: linear-gradient(108deg, #fa2dfc 0%, #325eff 100%);
  	border-radius: 4px;
    color: #ffffff;
    font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// src/components/rightnav/slide/search/vipLabel.vue